/**
 * `trip.routeMap` (the track API's `route_map`) lists every plant/stop the
 * trip visits, in order - the first entry is always the source and the last
 * is always the destination, with anything in between an intermediate stop.
 * For a round trip the last entry is just the source again (the trip loops
 * back to where it started), so it's dropped before applying that same
 * first/last rule - otherwise the destination pin would land on top of the
 * source pin and the real last stop would be miscounted as "intermediate".
 */
export const getRoutePoints = (trip) => {
  const routeMap = trip && trip.routeMap ? trip.routeMap : [];
  if (routeMap.length === 0) {
    return { source: trip ? trip.source : null, destination: trip ? trip.destination : null, intermediates: [] };
  }

  const points = trip.isRoundTrip && routeMap.length > 1 ? routeMap.slice(0, -1) : routeMap;

  return {
    source: points[0],
    destination: points[points.length - 1],
    intermediates: points.slice(1, -1),
  };
};
